/** Decodifica o payload do JWT (sem validar assinatura — só UX; API valida). null se inválido. */
function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

/** Lê claim must_chpwd do JWT (payload sem validar assinatura — só UX; API valida). */
export function jwtRequiresPasswordChange(token) {
  return decodeJwtPayload(token)?.must_chpwd === 'true'
}

/** Epoch em ms da expiração (claim exp) do JWT, ou null se ausente/inválido. */
export function jwtExpiresAtMs(token) {
  const exp = decodeJwtPayload(token)?.exp
  return typeof exp === 'number' ? exp * 1000 : null
}
